module.exports = __webpack_public_path__ + "static/img/animals2.e85b8597.jpg";